import { replaceTsWithNgInErrors } from '@angular/compiler-cli/src/ngtsc/diagnostics';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { RouterLinkWithHref } from '@angular/router';
import { CalendarFilter } from 'src/app/models/CalendarFilter';
import { Student, Vacation, VacationRow } from 'src/app/models/CalendarModels';
import { OptionSet } from 'src/app/models/OptionSet';
import { CalendarService } from 'src/app/services/calendar.service';


@Component({
  selector: 'app-vacation-list',
  templateUrl: './vacation-list.component.html',
  styleUrls: ['./vacation-list.component.scss']
})
export class VacationListComponent implements OnInit {
  public vacationRows: VacationRow[] = [];
  public vacationAllRows: VacationRow[] = [];
  public selectedRows: VacationRow[] = [];
  numberOfRows = 0;
  waitFotCancelSelected: number = 0;
  public allSelected: boolean = false;
  public dataSource: any;
  public studentsCountObject = {};
  @Output() selectedVacations = new EventEmitter<Vacation[]>();

  constructor(public calendarSvc: CalendarService) {

    //this.loadVacations(null);
    this.calendarSvc.classVacationSubject.subscribe((data: CalendarFilter) => {
      this.loadVacations(data);
    })

    this.calendarSvc.filterSubject.subscribe((data: CalendarFilter) => {
      this.filterRows(data);
    })
    this.calendarSvc.studentsSubject.subscribe(() => {
      if (this.vacationAllRows)
        this.vacationAllRows.forEach(item => {
          let v = this.calendarSvc.classVacsationsList.find(x => x.VacationId == item.VacationId);
          if (!item.StudentCount) {
            // item.StudentCount = this.countStudents(v.Class, v.ClassCode, v.Classification);
          }
        })
    });
  }

  ngOnInit(): void {
    this.loadVacations(null);
  }

  public loadVacations(callback) {
    //this.calendarSvc.getVacationsForClasses().then((res: any) => {
    //var x = JSON.parse(res);
    //this.calendarSvc.classVacsationsList = JSON.parse(res);
    this.calendarSvc.classVacationsListFiltered = this.calendarSvc.classVacsationsList;
    this.vacationRows = this.calendarSvc.classVacationsListFiltered.map(x => {
      let item: VacationRow = {
        Class: x.Class ? x.Class : null,
        ClassCode: x.ClassCode ? x.ClassCode : null,
        Classification: x.Classification ? x.Classification.viewValue : '',
        Camp:x.Camp ? x.Camp.viewValue : '',
        Name: x.Name,
        Date: x.Date,
        DateTo: x.DateTo,
        StudentCount: x.Students ? x.Students.length : 0, //this.countStudents(x.Class, x.ClassCode, x.Classification),
        VacationId: x.VacationId,
        VacationForAccountId: x.VacationForAccountId,
        _checked: false,
        Index: this.numberOfRows + 1,
        Status: x.Status?.viewValue
      };
      this.numberOfRows += 1;
      return item;
    });
    this.vacationAllRows = this.vacationRows;
    this.dataSource = this.vacationRows;
    this.allSelected = false;
    this.selectedRows = [];
    this.selectedVacations.emit(null);
    // if (callback)
    this.filterRows(this.calendarSvc.dataFilter);
    //});
    this.calendarSvc.spinnerSubjectEmit(false);
  }


  /**
 * Filter function. another same function at .\..\student-list\student-list.component.ts
 * @param dataFilter filter paramteres
 */
  filterRows(dataFilter: CalendarFilter) {
    if (dataFilter.clearFilter) {
      this.vacationRows = this.vacationAllRows;
    }
    else {
      this.vacationRows = this.vacationAllRows;
      if (dataFilter.ClassesValues.length > 0) {
        this.vacationRows = this.vacationRows.filter(row => {
          return row.Class && dataFilter.ClassesValues.includes(row.Class.viewValue)
        })
      }
      // if (dataFilter.ClassesCodesValues.length > 0) {
      //   this.vacationRows = this.vacationRows.filter(row => dataFilter.ClassesCodesValues.includes(row.ClassCode))
      // }
      if (dataFilter.ClassAndCode.length > 0) {
        this.vacationRows = this.vacationRows.filter(row => row.Class && row.ClassCode && dataFilter.ClassAndCode.some(x => x.Class == row.Class.value && x.ClassCode == row.ClassCode.value));
      }
      if (dataFilter.ClassificationValues.length > 0) {
        this.vacationRows = this.vacationRows.filter(row => dataFilter.ClassificationValues.includes(row.Classification))
      }
      if (dataFilter.Camp!= "") {
        this.vacationRows = this.vacationRows.filter(row => row.Camp == dataFilter.Camp)
      }
    }
    this.dataSource = this.vacationRows;
  }


  pageOfItems: Array<any>;
  onChangePage(pageOfItems: Array<any>) {
    this.pageOfItems = pageOfItems;
  }

  onSelectRow(item: VacationRow) {
    if (item._checked) {
      this.selectedRows.push(item);
      if (this.selectedRows.length == this.vacationRows.length)
        this.allSelected = true;
      if(item.Status != 'ממתין לביטול'){
          this.waitFotCancelSelected++;
        }
    }
    else {
      let i: number;
      i = this.GetVacationSelectedIndex(item);
      this.selectedRows.splice(i, 1);
      this.allSelected = false;
      if(item.Status != 'ממתין לביטול'){
        this.waitFotCancelSelected--;
      }
    }
    let record = this.calendarSvc.classVacationsListFiltered.find(x => x.VacationForAccountId == item.VacationForAccountId);
    if (record.Class){
      this.calendarSvc.filterCalendarWidely(this.selectedRows.map(rw => {return {...rw, Class:rw.Class.viewValue}}));
    }
    else this.calendarSvc.filterStudentsWidely(item._checked ? record.Students : null);

    //show vacation for update
    let selectedVacations: Vacation[] = this.selectedRows.map(item => {
      return this.calendarSvc.classVacationsListFiltered.find(x => x.VacationForAccountId == item.VacationForAccountId)
    });
    this.selectedVacations.emit(selectedVacations);
    if(this.waitFotCancelSelected == 0)
      this.calendarSvc.vacationChosen.next([]);
    else
      this.calendarSvc.vacationChosen.next(this.selectedRows);
  }
  GetVacationSelectedIndex(item: VacationRow): number {
    return this.selectedRows.findIndex(s => s.Index == item.Index); //לבדוק אם זה התנאי הנכון
  }

  selectAllRows() {
    if (this.allSelected) {
      this.vacationRows.forEach(row => {
        row._checked = false;
      });
      this.allSelected = false;
      this.selectedRows = [];
      this.waitFotCancelSelected = 0;

    }
    else {
      this.vacationRows.forEach(row => {
        row._checked = true;
        if(row.Status != 'ממתין לביטול'){
          this.waitFotCancelSelected++;
        }
      })
      this.allSelected = true;
      this.selectedRows = this.vacationRows.filter(x => true);
    }

    let selectedVacations: Vacation[] = this.selectedRows.map(item => {
      return this.calendarSvc.classVacationsListFiltered.find(x => x.VacationId == item.VacationId)
    });
    this.selectedVacations.emit(selectedVacations);

    if(this.waitFotCancelSelected == 0)
      this.calendarSvc.vacationChosen.next([]);
    else
      this.calendarSvc.vacationChosen.next(this.selectedRows);
  }

  countStudents(_class: OptionSet, _classcode: OptionSet, _classification: OptionSet) {
    var res = this.calendarSvc.studentsList.filter(x => x.Class?.value == _class.value);
    if (_classcode) {
      res = res.filter(x => x.ClassCode?.viewValue == _classcode.viewValue);
    }
    else {
      res = res.filter(x => !x.ClassCode);
    }
    if (_classification) {
      res = res.filter(x => x.Classification?.viewValue == _classification.viewValue);
    }
    return res.length;
  }
}
